const m = window.require("@ember/object/internals");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;